<template>
  <div class='menu-wrapper'>
    <template v-for="item in routes">
		<!--无子菜单-->
      <router-link :key="item.name" v-if="!item.hidden&&item.noDropdown&&item.children.length>0" :to="item.path+'/'+item.children[0].path">
        <el-menu-item :index="item.path+'/'+item.children[0].path" class='submenu-title-noDropdown'>
          <!--<icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg>-->
          <i v-if='item.icon' :class=" 'iconfont ' + item.icon  ">&nbsp;&nbsp;</i>
          <span>{{item.children[0].name}}</span>
        </el-menu-item>
      </router-link>
		<!--有子菜单-->
      <el-submenu :key="item.name" :index="item.name" v-if="!item.noDropdown&&!item.hidden && item.children && item.children.length>0">
        <template slot="title">
          <!--<icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg>-->
          <i v-if='item.icon' :class=" 'iconfont ' + item.icon  ">&nbsp;&nbsp;</i>
          <span>{{item.name}}</span>
        </template>
        <template v-for="child in item.children" v-if='!child.hidden'>
			<!--子菜单有子菜单，递归自身组件-->
          <sidebar-item :key="child.name" class='nest-menu' v-if='child.children&&child.children.length>0' :routes='[child]'> </sidebar-item>

          <router-link :key="child.name" v-else :to="item.path+'/'+child.path">
            <el-menu-item :index="item.path+'/'+child.path">
              <!--<icon-svg v-if='child.icon' :icon-class="child.icon"></icon-svg>-->
              <i v-if='child.icon' :class=" 'iconfont ' + child.icon  ">&nbsp;&nbsp;</i>
              <span>{{child.name}}</span>
            </el-menu-item>
          </router-link>

        </template>

      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  }
}
</script>
<style>
.el-submenu__title i{
  margin-right: 5px;
}
.el-menu-item i{
  margin-right: 5px;
}
</style>
